import { DesktopCigarettePreview } from './DesktopCigarettePreview';

export default DesktopCigarettePreview;
